"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgFlag03 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M21.005 2.291a1.544 1.544 0 0 0-.79-.275C20.036 2 19.822 2 19.62 2H4a1 1 0 0 0-1 1v18a1 1 0 1 0 2 0v-7h14.62c.202 0 .416 0 .595-.016.183-.017.499-.061.79-.275a1.5 1.5 0 0 0 .605-1.07 1.544 1.544 0 0 0-.17-.818c-.078-.162-.189-.346-.292-.519L19.166 8l1.982-3.302c.104-.173.214-.357.292-.519.08-.165.204-.459.17-.818a1.5 1.5 0 0 0-.605-1.07Z", fill: "currentColor" }) }))); };
exports.default = SvgFlag03;
